import * as React from 'react';
import PageHeadingSimple from 'ted-ui/build/PageHeadingSimple';
import Grid from '@able/react/dist/Grid';
import { OrderDetailsPageHeaders } from '../../../../config/order-tracker-new-common/constants';
import '../../style.less';

const iconDevelopmentURL = require('../../../../../../images/able-sprites.svg');

const OrderDetailsHeader = ({ orderNumber }: { orderNumber: string }) => {
  return (
    <Grid>
      <PageHeadingSimple
        headingType="Callout"
        SurfaceVariant="materialBaseSecondary"
        developmentUrl={iconDevelopmentURL}
        pageHeading={OrderDetailsPageHeaders.OrderDetails}
        headingDescription={''}
        messageSection={false}
        Callout={orderNumber}
        description={''}
        variant={'Attention'}
        data-testid="order-id-header"
        lozengeSection={null}
      />
    </Grid>
  );
};

export default OrderDetailsHeader;
